export const AUTH_EVENT_TYPES = {
  RESPOND_TO_AUTH_CHALLENGE: "RESPOND_TO_AUTH_CHALLENGE",
  RENEW_VERIFICATION_CODE: "RENEW_VERIFICATION_CODE",
  SIGN_IN: "SIGN_IN",
};

export const AUTH_CHALLENGE_NAMES = {
  NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
  SOFTWARE_TOKEN_MFA: "SOFTWARE_TOKEN_MFA",
  SMS_MFA: "SMS_MFA",
};

export const AUTH_API_PATHS = {
  SIGN_IN: "signin",
  VERIFICATION_CODE: "verification-code",
};

export const MFA_API_PATHS = {
  GET_STATUS: "mfa/get-status",
  ENABLE: "mfa/enable-mfa",
  DISABLE: "mfa/disable-mfa",
  SEND_PHONE_CODE: "mfa/send-phone-verification-code",
  VERIFY_PHONE: "mfa/verify-phone",
  UPDATE_PHONE: "mfa/update-phone-number",
  ASSOCIATE_SOFTWARE_TOKEN: "mfa/associate-software-token",
  VERIFY_SOFTWARE_TOKEN: "mfa/verify-software-token",
  ENABLE_SOFTWARE_TOKEN: "mfa/enable-software-token-mfa",
};

export const AUTH_FLOW = {
  ADMIN_NO_SRP_AUTH: "ADMIN_NO_SRP_AUTH",
};

export const HTTP_METHODS = {
  POST: "POST",
  GET: "GET",
};
